import {
  propertyTypesByLoanSubtype as _temp
} from '@roc/feature-utils';

export const propertyTypesByLoanSubtype = _temp;
